import { combineReducers } from 'redux';
import { currentMerchantReducer } from './currentMerchant';
import { currentAppReducer } from './currentApp';
import { currentSidebarReducer } from './currentSidebar';
import { notificationsReducer } from './notifications';
import { sessionPermissionsReducer } from './sessionPermissions';
import { currentOverlayReducer } from './currentOverlay';
import { currentAccountReducer } from './currentAccount';
import { currentModalReducer } from './currentModal';
import {
  currentModalAppReducer,
  initialModalAppState,
} from './currentModalApp';
import { actionPanelReducer } from './actionPanel';
import { initializationReducer } from './initialization';
import { whiteLabelReducer } from './whiteLabel';
import { routingReducer } from './routing';
import { documentHeadersReducer } from './documentHeaders';
import { hubspotReducer } from './hubspot';
import { intercomReducer } from './intercom';
import { bookingConfigsReducer } from './bookingConfigs';

export const currentMerchant = currentMerchantReducer;
export const currentApp = currentAppReducer;
export const currentSidebar = currentSidebarReducer;
export const currentOverlay = currentOverlayReducer;
export const notifications = notificationsReducer;
export const sessionPermissions = sessionPermissionsReducer;
export const currentAccount = currentAccountReducer;
export const currentModal = currentModalReducer;
export const currentModalApp = currentModalAppReducer;
export const actionPanel = actionPanelReducer;
export const initialization = initializationReducer;
export const whiteLabel = whiteLabelReducer;
export const routing = routingReducer;
export const documentHeaders = documentHeadersReducer;
export const hubspot = hubspotReducer;
export const intercom = intercomReducer;
export const bookingConfigs = bookingConfigsReducer;
export { initialModalAppState };

export default combineReducers({
  currentAccount,
  currentApp,
  currentMerchant,
  currentModal,
  currentModalApp,
  currentOverlay,
  currentSidebar,
  documentHeaders,
  initialization,
  notifications,
  routing,
  whiteLabel,
  actionPanel,
  hubspot,
  intercom,
  sessionPermissions,
  bookingConfigs,
});
